export default __webpack_public_path__ + "static/media/close.97f9f204.svg";